export default "__VITE_ASSET__BVDysPcG__"